export default {
  items: [
    {
      name: 'ড্যাশবোর্ড',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary',
        // text: 'NEW'
      }
    },
    {
      name: 'সিটিজেন',
      url: '/accounts/list',
      icon: 'fa fa-address-card-o'
    },
    {
      name: 'আবেদন',
      url: '/application',
      icon: 'fa fa-star',
      children: [
        {
          name: 'পানি',
          url: '/water',
          icon: 'fa fa-tint',
          children: [
            {
              name: 'নতুন সংযোগ',
              url: '/application/water/new-connection',
              icon: 'fa fa-plus'
            },
            {
              name: 'সংযোগ বাতিল',
              url: '/application/water/remove-connection',
              icon: 'fa fa-trash'
            },
            {
              name: 'হালনাগাদ সংযোগ',
              url: '/application/water/update-connection',
              icon: 'fa fa-refresh'
            }
          ]
        },
        {
          name: 'মার্কেট',
          url: '/market',
          icon: 'fa fa-building',
          children: [
            {
              name: 'মার্কেট লিজ',
              url: '/application/market/new-connection',
              icon: 'fa fa-plus'
            },
            {
              name: 'মালিকানা পরিবর্তন',
              url: '/application/market/ownership-change',
              icon: 'fa fa-plus'
            },
            {
              name: 'বন্ধ দোকান চালু',
              url: '/application/market/close-shop-open',
              icon: 'fa fa-plus'
            }
          ]
        },
          // {
          //     name: 'হোল্ডিং',
          //     url: '/holding',
          //     icon: 'fa fa-money',
          //     children: [
          //         {
          //             name: 'হোল্ডিং লিস্ট',
          //             url: '/holding/approved-list',
          //             icon: 'fa fa-object-ungroup'
          //         },
          //         {
          //             name: 'হোল্ডিং রিকুয়েস্ট ',
          //             url: '/holding/pending-list',
          //             icon: 'fa fa-object-ungroup'
          //         },
          //     ]
          // },
          {
            name: 'পানি (অফিস)',
            url: '/water',
            icon: 'fa fa-superpowers',
            children: [
              {
                name: 'নতুন সংযোগ',
                url: '/application/water-ofc/new-connection',
                icon: 'fa fa-plus'
              },
              {
                name: 'সংযোগ বাতিল',
                url: '/application/water-ofc/remove-connection',
                icon: 'fa fa-trash'
              },
              {
                name: 'হালনাগাদ সংযোগ',
                url: '/application/water-ofc/update-connection',
                icon: 'fa fa-refresh'
              },
            ]
          },
          {
            name: 'অন্যান্য লিজ',
            url: '/other-lease',
            icon: 'fa fa-university',
            children: [
              {
                name: 'নতুন লিজ',
                url: '/application/other-lease/new-connection',
                icon: 'fa fa-plus'
              },
              {
                name: 'মালিকানা পরিবর্তন',
                url: '/application/other-lease/ownership-change',
                icon: 'fa fa-plus'
              },
              {
                name: 'বন্ধ লিজ চালু',
                url: '/application/other-lease/close-shop-open',
                icon: 'fa fa-plus'
              }
            ]
          },
      ]
    },

    {
      name: 'বিল',
      url: '/water-billing',
      icon: 'fa fa-money',
      children: [
        {
          name: 'পানির বিল',
          url: '/water-billing/list',
          icon: 'fa fa-object-ungroup'
        },
        {
          name: 'মার্কেটের বিল',
          url: '/market-billing/list',
          icon: 'fa fa-object-ungroup'
        },
        {
          name: 'পানির বিল (অফিস)',
          url: '/water-ofc-billing/list',
          icon: 'fa fa-object-ungroup'
        },
        {
          name: 'অন্যান্য লিজ বিল',
          url: '/other-lease-billing/list',
          icon: 'fa fa-object-ungroup'
        }
      ]
    },

    {
      name: 'রিপোর্ট',
      url: '/report',
      icon: 'fa fa-bar-chart',
    },
    {
      name: 'সার্ভিস',
      url: '/item',
      icon: 'fa fa-cog',
      children: [
        {
          name: 'সার্ভিস লিস্ট',
          url: '/item',
          icon: 'fa fa-object-ungroup'
        },
        {
          name: 'সার্ভিস ক্যাটাগরি',
          url: '/category',
          icon: 'fa fa-object-ungroup'
        },
      ]
    },
    {
      name: 'সেটিংস্‌',
      url: '/holding-list',
      icon: 'fa fa-money',
      children: [
        {
          name: 'রাস্তার লিস্ট',
          url: '/road-list',
          icon: 'fa fa-object-ungroup'
        },
        {
          name: 'কাস্টমার ধরন',
          url: '/customer-list',
          icon: 'fa fa-object-ungroup'
        },
        {
          name:'ব্যাংক',
          url:'/bank-list',
          icon:'fa fa-object-ungroup'
        },
        {
          name:'মার্কেট',
          url:'/market-list',
          icon:'fa fa-object-ungroup'
        }
      ]
    },
  ],
}
